import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import get from 'lodash/get';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleApplicationType = (
  vehicle: DashboardVehicle,
): ApplicationType | undefined => {
  return get(vehicle, 'application.applicationType');
};
